import { FC, useCallback } from 'react';
import { toast } from 'react-toastify';

import { CopyIcon } from '../../assets/icons/index';
import { Company, User } from '../../hooks/index';
import { isInternalCapQuestEmail } from '../../utils/is-internal-capquest-email.util';
import { AppFormattedMessage } from '../app-formatted-message/index';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '../hover-card/index';
import { SideBarItem } from './side-bar-item';

export type CopyCompanyIdItemProps = {
  isExpanded: boolean;
  onCopied?: () => void;
};

export const CopyCompanyIdItem: FC<CopyCompanyIdItemProps> = ({ isExpanded, onCopied }) => {
  const { user } = User.useUser();
  const { selectedCompanyId } = Company.useSelected();

  const isVisible = Boolean(selectedCompanyId) && isInternalCapQuestEmail(user?.email);

  const handleCopy = useCallback(() => {
    onCopied?.();

    const copy = navigator.clipboard?.writeText?.(selectedCompanyId);

    if (!copy) {
      toast.error(selectedCompanyId);
      return;
    }

    copy.then(
      () => toast.success(<AppFormattedMessage id="COMPANY_ID_COPIED" />),
      () => toast.error(selectedCompanyId),
    );
  }, [onCopied, selectedCompanyId]);

  if (!isVisible) return null;

  return (
    <HoverCard>
      <HoverCardTrigger>
        <SideBarItem
          Icon={CopyIcon}
          isExpanded={isExpanded}
          isSelected={false}
          onClick={handleCopy}
          title="COPY_COMPANY_ID"
        />
      </HoverCardTrigger>
      {!isExpanded && (
        <HoverCardContent
          className="z-20 w-max rounded-lg bg-[#101828] px-3 py-2"
          isShownTriangle
          side="right"
          sideOffset={8}
          triangleClassName="left-0 top-1/2 transform -translate-y-1/2 "
        >
          <span className="text-label-md font-[550] text-white">
            <AppFormattedMessage id="COPY_COMPANY_ID" />
          </span>
        </HoverCardContent>
      )}
    </HoverCard>
  );
};
